import React from 'react';
import { Web3Provider } from '@ethersproject/providers';
import { Web3ReactProvider } from '@web3-react/core';

import {
  ChainProvider,
  PortfolioProvider,
  PriceProvider,
  SettingsProvider,
  StatsProvider,
} from 'contexts';
import AppContent from './AppContent';

const App = () => (
  <Web3ReactProvider getLibrary={(provider) => new Web3Provider(provider)}>
    <ChainProvider>
      <PriceProvider>
        <StatsProvider>
          <PortfolioProvider>
            <SettingsProvider>
              <AppContent />
            </SettingsProvider>
          </PortfolioProvider>
        </StatsProvider>
      </PriceProvider>
    </ChainProvider>
  </Web3ReactProvider>
);

export default App;
